import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class TourPackageService {
  static gettravelPackageList(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.gettravelPackage}?id=${item?.id}`
      } 
      else
      if(item?.categoryId){
        api= `${API_BASE_URL}${API_PATHS.gettravelPackage}?limit=${item?.limit}&page=${item?.page}&categoryId=${item?.categoryId}`
     } 
     else
     if(item?.duration){
       api= `${API_BASE_URL}${API_PATHS.gettravelPackage}?limit=${item?.limit}&page=${item?.page}&duration=${item?.duration}`
    } 
     else{
      api = `${API_BASE_URL}${API_PATHS.gettravelPackage}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addtravelPackage(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addtravelPackage}`;
    return axiosInstance
        .post(api,item)
        
}
static edittravelPackage(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.edittravelPackage}`;
    return axiosInstance
        .put(api,item)
        
}
static deletetravelPackage(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deletetravelPackage}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deletetravelPackage}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default TourPackageService;